import { Card, Group, Stack, Skeleton } from "@mantine/core";

export const NotificationSkeleton = () => {
    return (
        <Card 
            padding="lg" 
            radius="md" 
            withBorder 
            style={{ borderColor: '#f5f5f5', cursor: 'pointer', borderWidth: 1 }}
        >
            <Stack align="end">
                <Group w="100%" gap="md" align="center">
                    <Skeleton height={48} width={48} circle />
                    <Skeleton height={20} width="80%" />
                </Group>
                <Group gap={5}>
                    <Skeleton height={20} width={80} radius="sm" />
                    <Skeleton height={20} width={80} radius="sm" />
                    <Skeleton height={20} width={80} radius="sm" />
                </Group>
            </Stack>
        </Card>
    );
};